export class RelatedCommissionAccounts {
    constructor(value?: any) {
        this.commissionAccount_Id = value.id;
        this.name = value.name;
    }
    commissionAccount_Id: string;
    name: string
}